import React from "react";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Sarah Johnson",
    review: "Absolutely love my custom necklace! The quality is stunning and the design is exactly what I wanted.",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?q=80&w=1742&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    video: "/assets/videos/jewel.mp4",
  },
  {
    name: "Michael Smith",
    review: "I gifted my wife a personalized bracelet, and she was thrilled! Highly recommended!",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    video: "/assets/videos/galary.mp4",
  },
  {
    name: "Emily White",
    review: "The diamonds are so sparkly! The craftsmanship is top-notch, and it was delivered on time.",
    image: "https://images.unsplash.com/photo-1631947430066-48c30d57b943?q=80&w=1616&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    video: "/assets/videos/showof.mp4",
  },
];

function Testimonials() {
  return (
    <section className="testimonials">
      <h2 className="testimonials__title">What Our Customers Say</h2>
      <div className="testimonials__container">
        {testimonials.map((testimonial, index) => (
          <div className="testimonial-card fade-in" key={index}>
            <img src={testimonial.image} alt={testimonial.name} className="testimonial__image" />
            <p className="testimonial__review">"{testimonial.review}"</p>
            <h4 className="testimonial__name">{testimonial.name}</h4>
            {testimonial.video && (
              <video controls className="testimonial__video">
                <source src={testimonial.video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
